module.exports = __webpack_public_path__ + "img/Help.16edbcef.svg";